import { useLang } from 'hooks/lang';

import { TaskWithSub } from 'entities';

import { Row, Tag } from 'components/Blocks';
import { ServiceOutsourcedTag } from 'pages/Projects/components';

interface TaskTagsProps {
  children?: never;
  className: string;
  task: TaskWithSub;
}

export function TaskTags({ className, task }: TaskTagsProps) {
  const { t } = useLang();

  const { tags, activeRecruitments, outsourced } = task;

  if (!tags.length && !activeRecruitments && !outsourced) return null;

  return (
    <Row className={className} flexWrap="wrap" gap="2">
      {outsourced && <ServiceOutsourcedTag />}

      {!!activeRecruitments && <Tag name={t('recruiting')} color="success" />}

      {tags.map(({ tag }) => (
        <Tag key={tag.id} {...tag} />
      ))}
    </Row>
  );
}
